import { z } from "zod";
import { TemplateIdSchema } from "./templates.js";

export const SITE_IDS = [
  "trackhantavirus",
  "hantavirusrealtime",
  "hantavir-us",
] as const;

export const THEME_IDS = [
  "tokyo-night",
  "nord",
  "catppuccin-latte",
  "vercel",
  "dracula",
  "cyberpunk",
  "supabase",
] as const;

export const SiteIdSchema = z.enum(SITE_IDS);
export type SiteId = z.infer<typeof SiteIdSchema>;

export const ThemeIdSchema = z.enum(THEME_IDS);
export type ThemeId = z.infer<typeof ThemeIdSchema>;

export const ResendConfigSchema = z.object({
  apiKey: z.string().min(1, "SITE_RESEND_API_KEY is required"),
  fromAddress: z.string().email("SITE_RESEND_FROM must be an email"),
  sendingDomain: z.string().min(1, "SITE_RESEND_DOMAIN is required"),
});

export const MonetagZonesSchema = z.object({
  popunder: z.string().optional(),
  inPagePush: z.string().optional(),
  vignette: z.string().optional(),
  push: z.string().optional(),
  smartlink: z.string().optional(),
});

export const MonetagConfigSchema = z.object({
  publisherId: z.string().min(1),
  verificationMeta: z.string().min(1),
  zones: MonetagZonesSchema,
});

export const PwaConfigSchema = z.object({
  name: z.string().min(1),
  shortName: z.string().min(1).max(12),
  themeColor: z.string().regex(/^#[0-9a-fA-F]{6}$/),
  backgroundColor: z.string().regex(/^#[0-9a-fA-F]{6}$/),
  apkDownloadPath: z.string().startsWith("/"),
});

export const SiteSchema = z.object({
  id: SiteIdSchema,
  hostname: z.string().min(1),
  themeId: ThemeIdSchema,
  templateId: TemplateIdSchema,
  resend: ResendConfigSchema,
  monetag: MonetagConfigSchema,
  pwa: PwaConfigSchema,
});

export type Site = z.infer<typeof SiteSchema>;
